import React from 'react';

import css from './LinkList.module.css';

const LinkList = ({ links } = {}) => (
  <>
    <div className={css.linkList}>
      <div className={css.region}>
        {links.map((link, index) =>
          link.url === null ? (
            <span key={`${link.title}-${index}`} className={css.link}>
              {link.title}
            </span>
          ) : (
            <a key={`${link.title}-${index}`} href={link.url} className={css.link}>
              {link.title}
            </a>
          ),
        )}
      </div>
    </div>
  </>
);

export default LinkList;
